<template>
<div class="main">
  <div class="learn-content">
    <div class="container">
      <h1 id="-">{{ learnItem.title }}</h1>
      <div v-if="learnItem.authorName !== '3kyaku'" class="learn-author slim">
        <div class="thumb">
          <img :src="learnItem.authorThumbnail" :alt="learnItem.authorName">
        </div>
        <div class="text">
          <div class="author-name"><span>執筆者</span>{{ learnItem.authorName }}<span class="author-positon">{{ learnItem.authorPosition }}</span></div>
        </div>
      </div>
      <img :src="learnItem.thumbnail" :alt="learnItem.title">
        <vue-markdown :source="source"></vue-markdown>
    </div>
  </div>
  <div class="social-share">
    <div class="text-center"><strong>この記事をシェア</strong></div>
    <ul class="text-center">
      <li><a id="footer-social-share-twitter"
           :href="'http://twitter.com/intent/tweet?url=https://3kyaku.jp'+$route.fullPath+'&text='+learnItem.title+'&hashtags=3kyaku'"
           rel="nofollow"
           target="_blank"><img src="/common/social-share/icon-twitter.svg" alt="Twiterでシェア"></a></li>
      <li><a id="footer-social-share-facebook"
           :href="'http://www.facebook.com/share.php?u=https://3kyaku.jp'+$route.fullPath"
           rel="nofollow"
           target="_blank"><img src="/common/social-share/icon-facebook.svg" alt="Facebookでシェア"></a></li>
      <li><a id="footer-social-share-hatena"
           :href="'http://b.hatena.ne.jp/add?mode=confirm&url=https://3kyaku.jp'+$route.fullPath+'&title='+learnItem.title"
           rel="nofollow"
           target="_blank"><img src="/common/social-share/icon-hatena.svg" alt="はてなブックマーク"></a></li>
      <li><a id="footer-social-share-line"
           :href="'http://line.me/R/msg/text/?'+learnItem.title+' https://3kyaku.jp'+$route.fullPath"
           rel="nofollow"
           target="_blank"><img src="/common/social-share/icon-line.svg" alt="LINEに送る"></a></li>
    </ul>
  </div>

  <div class="container">
    <div v-if="learnItem.authorName !== '3kyaku'" class="learn-author">
      <div class="thumb">
        <img :src="learnItem.authorThumbnail" :alt="learnItem.authorName">
      </div>
      <div class="text">
        <div class="author-name"><span>執筆者</span>{{ learnItem.authorName }}</div>
        <p>{{ learnItem.authorProfile }}</p>
        <div class="author-link">
          <a :href="learnItem.authorUrl" target="_blank">{{ learnItem.authorUrl }}</a>
        </div>
      </div>
    </div>
    <div class="learn-author">
      <div class="thumb">
        <img src="/learn/images/thumb_mitsuo_ueno.png" alt="上野　光夫">
      </div>
      <div class="text">
        <div class="author-name"><span>監修者</span>上野　光夫</div>
        <p>中小企業診断士・資金調達コーディネーター®。>昭和３７年鹿児島市生まれ。九州大学を卒業後、日本政策金融公庫（旧国民生活金融公庫）に２６年間勤務し、主に中小企業への融資審査の業務に携わる。３万社の中小企業への融資と、５千名の起業家への創業融資を担当した。融資総額は2,000億円にのぼる。平成２３年４月にコンサルタントとして独立。起業支援コンサルティング、資金調達サポートを行うほか、研修、講演、執筆など幅広く活動している。リクルート社『アントレ』などメディア登場実績多数。日本最大の起業家支援プラットフォーム「ＤＲＥＡＭ　ＧＡＴＥ」において、アドバイザーランキング「資金調達部門」で３年連続して第１位に輝く。</p>
        <div class="author-link">
          <a href="https://mmconsulting.jp/" target="_blank">https://mmconsulting.jp/</a>
        </div>
      </div>
    </div>
    <script type="application/ld+json">
    [{
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://3kyaku.jp/learn/{{ learnItem.id }}"
    },
    "datePublished": "2018-11-01",
    "dateModified": "2018-11-01",
    "headline": "{{ learnItem.title }}",
    "Image": "https://3kyaku.jp{{ learnItem.thumbnail }}",
    "publisher": {
      "@type": "Organization",
      "name": "bizocen",
      "logo": {
        "@type": "ImageObject",
        "url": "https://3kyaku.jp/common/images/bizocea-logo.png",
        "width": 132,
        "height": 44
      }
    },
    "author": {
        "@type": "Person",
        "name": "{{ learnItem.authorName }}",
        "image": "https://3kyaku.jp{{ learnItem.authorThumbnail }}",
        "url": "{{ learnItem.authorUrl }}"
    },
    "editor": {
        "@type": "Person",
        "name": "上野光夫",
        "images": "https://3kyaku.jp/learn/images/thumb_mitsuo_ueno.png",
        "url": "https://mmconsulting.jp/"
    }
    }]
    </script>
  </div>

  <div class="learn-footer">
    <div class="text-center"><strong>事業計画書のキホン</strong></div>
    <div class="learn-index">
      <div v-for="item in learnItems"
        v-if="learnItem.id !== item.id"
        class="learn-item">
        <router-link v-bind:to="{name: 'learnDetail', params: {learnId: item.id}}">
          <div class="learn-item-inner">
            <div class="thumbnail">
              <img :src="item.thumbnail"
                :alt="item.title">
            </div>
            <div class="text">
              <h2 class="title">{{ item.title }}</h2>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="text-center">
      <router-link v-bind:to="{name: 'learnList'}">
        <Button>事業計画書のキホン一覧</Button>
      </router-link>
    </div>
  </div>
</div>
</template>
<script>
import VueMarkdown from 'vue-markdown'
import learnItemIndex from '@/assets/learn/index'
const axios = require('axios')
export default {
  data() {
    return {
      source: "",
      learnItem: {}
    }
  },
  props: ['learnId'],
  computed: {
    learnItems: function () {
      return learnItemIndex
    }
  },
  mounted: function () {
    this.loadLearnItem()
  },
  methods: {
    loadLearnItem: function(){
      const app = this
      this.learnItem = learnItemIndex.find(function (elem) {
        //console.log('elem', elem)
        if (elem['id'] === app.learnId) {
          return elem
        }
      })
      axios
        .get(this.learnItem.markdownPath)
        .then(response => (this.source = response.data))
        .catch(error => console.error(error))
    }
  },
  watch: {
    'learnId' (to, from) {
      this.loadLearnItem()
    }
  },
  components: {
    VueMarkdown
  }
}
</script>
